import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from "@mui/material/Typography";

import {getCaseLink, formatCaseName, formatCaseBillingType} from '../../helpers/cases';
import {formatPatientName, formatPatientPhone} from '../../helpers/patients';
import {formatProviderName} from '../../helpers/providers';
import { formatPlanCategory } from '../../helpers/payerPlans';
import {formatDate} from '../../helpers/dates';
import EditCaseStatus from './EditCaseStatus';
import EditCaseButton from './EditCaseButton';

const getColumns = ({viewCaseSessions}) => [
  {
    key: 'status',
    renderCellContent: c => <EditCaseStatus case={c} />,
  },
  {
    key: 'patient',
    renderCellContent: c => formatPatientName(c.patient),
  },
  {
    key: 'diagnosis_categories',
    renderCellContent: c => formatCaseName(c),
  },
  {
    key: 'first_session_date',
    renderCellContent: c => (
      <Typography variant='small500Inter'>
        {c.first_session_date ? formatDate(c.first_session_date, 'M/D/YYYY') : 'None'}
      </Typography>
    ),
  },
  {
    key: 'completion_date',
    renderCellContent: c => (
      <Typography variant='small500Inter'>
          {
          c.completion_date 
          ? formatDate(c.completion_date, 'M/D/YYYY')
          : 'Active'
        }
      </Typography>
    ),
  },
  {
    key: 'session_count',
    renderCellContent: c => (
      <Button size='small' variant='text' onClick={() => viewCaseSessions()}>
        <Typography variant='small500Inter'>
          {c.session_count}
        </Typography>
      </Button>
    ),
    align: 'center',
  },
  {
    key: 'billing_category',
    align: 'center',
    renderCellContent: c => formatCaseBillingType(c, {includePlanCategory: true}),
  },
  {
    key: 'providers',
    renderCellContent: c => (
      (c.providers || []).map(p => formatProviderName(p)).join(', ')
    ),
  },
  {
    key: 'edit',
    align: 'right',
    renderCellContent: c => (
      <EditCaseButton 
        caseId={c.id}
        size='small' 
        variant='text'
      />
    ),
  }
];

const CaseTableRow = props => {
  const navigate = useNavigate();
  const {data: c} = props;
  const url = getCaseLink(c);
  const viewCaseDetail = () => navigate(url);
  const preventParentEvent = (event) => {
    event.stopPropagation();
  };
  const sessionsPath = `/providers/sessions?case_id=${c.id}`;
  const viewCaseSessions = () => navigate(sessionsPath);
  const columns = getColumns({viewCaseSessions})
    .filter(col => props?.columns ? props?.columns.includes(col.key) : true);
  return (
    <TableRow
      key={c.id}
    >
      {columns.map((col, i) => (
        <TableCell 
          key={i} 
          align={col.align || 'left'} 
        >
          {col.renderCellContent(c)}
        </TableCell>
      ))}
    </TableRow>
  );
};

CaseTableRow.propTypes = {
  data: PropTypes.object,
  // buttons: PropTypes.arrayOf(PropTypes.element),
  // isPatient: PropTypes.bool,
  // afterSave: PropTypes.func,
};

export default CaseTableRow;
